import { EFlex } from "#webapp/src/util/event-tag.util";
import { Select, SelectOption } from "@clockwise/design-system";
import React from "react";

type Props = {
  isDisabled?: boolean;
  onChange: (flexibility: EFlex) => void;
  selectedFlex: EFlex | null;
};

export function AutopilotFormFlex({ selectedFlex, onChange, isDisabled }: Props) {
  return (
    <div className="cw-py-2 cw-w-full">
      <Select
        label="Timing flexibility"
        value={selectedFlex || ""}
        onChange={onChange}
        name="Timing flexibility"
        disabled={isDisabled}
        fullWidth
      >
        <SelectOption value={EFlex.Week}>Ok to move within the week</SelectOption>
        <SelectOption value={EFlex.Day}>Ok to move within the day</SelectOption>
      </Select>
    </div>
  );
}
